document.addEventListener('DOMContentLoaded', function() {
    const recentViewCurrentURL = window.location.pathname;
    
    const handleRegex = /\/products\/([\w-]+)/;
    const match = recentViewCurrentURL.match(handleRegex);
    
    if (match && match[1]) {
        const productHandle = match[1];
        
        let visitedHandles = [];
        try {
            const storedHandles = localStorage.getItem('recentProductHandles');
            if (storedHandles) {
                visitedHandles = JSON.parse(storedHandles) || [];
            }
        } catch (e) {
            console.error('Error parsing JSON from localStorage', e);
        }
        
        const excludedHandles = [
            'goddiva-unlimited',
            'heart-shaped-foil-shopper-bag-rose-gold-by-goddiva'
        ];

        if (!excludedHandles.includes(productHandle) && !window.hideOsProduct && !visitedHandles.includes(productHandle)) {
            visitedHandles.push(productHandle);
        }
        
        // Ensure only the last 5 handles are stored
        visitedHandles = visitedHandles.slice(-5);
        localStorage.setItem('recentProductHandles', JSON.stringify(visitedHandles));
    }
    
    let visitedHandles = [];
    try {
        const storedHandles = localStorage.getItem('recentProductHandles');
        if (storedHandles) {
            visitedHandles = JSON.parse(storedHandles) || [];
        }
    } catch (e) {
        console.error('Error parsing JSON from localStorage', e);
    }

    const container = document.querySelector('.recentlyviewed__container');
    const wrapper = document.querySelector('.recently-viewed-container-wrapper');
    
    if (visitedHandles.length === 0) {
        if (wrapper) {
            wrapper.style.display = 'none';
        }
        return;
    }
    
    if (container) {
        container.classList.add('loading');
    }
    
    let loadedHandlesCount = 0;

    // Fetch and append products from only the last 5 visited handles
    visitedHandles = visitedHandles.slice(-5).reverse();

    visitedHandles.forEach(handle => {
        const productUrl = `${window.origin}/products/${handle}?view=ajax_recently_viewed_new`;
        
        fetch(productUrl)
            .then(response => {
              if (!response.ok || response.redirected) {
                console.log('Response: ', handle);
                
                let allHandles = [];
                try {
                    allHandles = JSON.parse(localStorage.getItem('recentProductHandles')) || [];
                } catch (e) {
                    console.error('Error parsing JSON from localStorage', e);
                }
                
                if (allHandles.indexOf(handle) != -1) {
                    allHandles.splice(allHandles.indexOf(handle), 1);
                    localStorage.setItem('recentProductHandles', JSON.stringify(allHandles));
                }
                return null;
              }
              return response.text();
            })
            .then(html => {
                if (html != null && container) {
                    container.insertAdjacentHTML('beforeend', html);
                }

                loadedHandlesCount++;
              
                if (loadedHandlesCount === visitedHandles.length) {
                    if (container && container.classList.contains('loading')) {
                        container.classList.remove('loading');
                        initRecentViewSlider();
                    }
                }
            })
            .catch(error => {
                console.error('Error fetching product:', error);
                
                loadedHandlesCount++;
                
                if (loadedHandlesCount === visitedHandles.length) {
                    if (container && container.classList.contains('loading')) {
                        container.classList.remove('loading');
                        initRecentViewSlider();
                    }
                }
            });
    });
    
    function initRecentViewSlider() {
        if (container) {
            const itemsToShow = parseInt(container.getAttribute('data-item-to-show'), 10) || 1;
            const dots = container.getAttribute('data-item-dots') === 'true';
            const dotsMb = container.getAttribute('data-item-dots-mb') === 'true';
            const arrows = container.getAttribute('data-item-arrows') === 'true';
            const arrowsMb = container.getAttribute('data-item-arrows-mb') === 'true';
            $(container).slick({
                slidesToShow: itemsToShow,
                slidesToScroll: 1,
                dots: dots,
                arrows: arrows,
                responsive: [
                  {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 3,
                            dots: dots,
                            arrows: arrows
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            swipe: true,
                            swipeToSlide: true,
                            slidesToShow: 2,
                            dots: dotsMb,
                            arrows: arrowsMb
                        }
                    }
                ]
            });
        }
    }
});